module.exports = __webpack_public_path__ + "static/socialSharing-b97fb48b901642071105687bd891d475.png";